import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from '../Button';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaTimes } from "react-icons/fa";
import toast from 'react-hot-toast';
import { archiveCommittee } from '../../api/admin/AdminDashboardAPI';

Modal.setAppElement('#root');

const CommitteeArchiveModal = ({ isOpen, onClose, committee, updateCommitteesAfterRestoreOrArchive }) => {
    const handleArchive = (committeeArch) => {
        toast.loading("Archiving Committee...");
        setTimeout(async () => {
            try {
                const response = await archiveCommittee(committeeArch);
                if (response.status === 200 || response.status === 201) {
                    toast.dismiss();
                    toast.success("Committee archived!");
                    const updatedCommittee = {
                        ...committeeArch,
                        archived: true
                    }
                    updateCommitteesAfterRestoreOrArchive(updatedCommittee);
                    onClose();
                } else {
                    toast.dismiss();
                    toast.error("Committee failed to archive. Status: " + response.status);
                }
            } catch (error) {
                toast.dismiss();
                console.error("Error archiving committee:", error);
                toast.error("Something went wrong. Please check your connection and try again.");
            }
        }, 300);
    }


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Committee Archive Modal"
            className="custom-modal-content delete-modal-committee"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                    <h2 className="text-start fs-4 mb-0">Are you sure you want to archive this committee?</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-center align-items-center two-button-container'>
                    <div className='me-3'>
                        <Button
                            id="filter-button-modal"
                            type={BUTTON_TYPES.outline}
                            buttonText="Cancel"
                            action={() => { onClose() }}
                        />
                    </div>
                    <Button
                        id="delete-event-confirm-button"
                        type={BUTTON_TYPES.danger}
                        buttonText="Confirm"
                        action={() => { handleArchive(committee) }}
                    />
                </div>
            </>
        </Modal>
    );
};

CommitteeArchiveModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    committee: PropTypes.object.isRequired,
};

export default CommitteeArchiveModal;
